"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _conditionalRendering = require("./conditionalRendering");
var _checkConditions = require("./checkConditions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var CustomTextField = props => {
  var text = props.field.model.text,
    htmlTag = props.field.model.htmlTag,
    css = props.field.model.cssClass + " mm-spacing--minor",
    shouldHide;
  var field = props.field,
    state = _conditionalRendering.store.getState();
  var conditionId = field.model.conditionSettings.fieldKey;
  if (state !== undefined) {
    if (state.conditions[conditionId] !== undefined) shouldHide = (0, _checkConditions.checkConditions)(state.fieldValues, state.conditions[conditionId]);
  }
  var textElement = /*#__PURE__*/_react.default.createElement(htmlTag, {
    className: css
  }, text);
  if (shouldHide) {
    return null;
  } else {
    return textElement;
  }
};
var _default = exports.default = CustomTextField;